export const GET_USER_TALK_SUCCESS = "GET_USER_TALK_SUCCESS";
export const GET_USER_TALK_FAILURE = "GET_USER_TALK_FAILURE";

export const USER_TALK_PAYMENT_SUCCESS = "USER_TALK_PAYMENT_SUCCESS";
export const USER_TALK_PAYMENT_FAILURE = "USER_TALK_PAYMENT_FAILURE";

export const USER_TALK_MANUAL_PAYMENT_SUCCESS = "USER_TALK_MANUAL_PAYMENT_SUCCESS";
export const USER_TALK_MANUAL_PAYMENT_FAILURE = "USER_TALK_MANUAL_PAYMENT_FAILURE";

export const USER_TALK_RECEIPT_SUCCESS = "USER_TALK_RECEIPT_SUCCESS";
export const USER_TALK_RECEIPT_FAILURE = "USER_TALK_RECEIPT_FAILURE";
